import React from 'react';
import { Box, Text, Image } from '@chakra-ui/react';
import access_denied from 'assets/access_denied.png';

const AccessDenied = () => {
  return (
    <Box
      textAlign="center"
      borderRadius="md"
      boxShadow="md"
      p={2}
      bg="gray.50"
      maxW="600px"
      ml="auto"
      mr="auto"
      mt={20}
      mb={4}
    >
      <Image src={access_denied} alt="Access Denied" w="100%" />
      <Text fontSize="2xl" fontWeight="bold" color="red.600">
        Access Denied
      </Text>
      <Text fontSize="md" color="gray.600">
        You do not have permission to view this page.
      </Text>
    </Box>
  );
};

export default AccessDenied;
